import { extendedEvent, method, composeEventName } from '../support/index';
var defaultEvents = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel'];
var oneMinute = 60e3;
var defaultOptions = {
  ms: oneMinute,
  initialState: false,
  events: defaultEvents,
  dispatchEvent: true,
  eventPrefix: true
};
export var useIdle = function useIdle(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _Object$assign = Object.assign({}, defaultOptions, options),
      ms = _Object$assign.ms,
      initialState = _Object$assign.initialState,
      events = _Object$assign.events,
      dispatchEvent = _Object$assign.dispatchEvent,
      eventPrefix = _Object$assign.eventPrefix;

  var isIdle = initialState;
  var timeout = setTimeout(function () {
    isIdle = true;
    dispatchAway();
  }, ms);

  var dispatchAway = function dispatchAway(event) {
    var eventName = composeEventName('away', controller, eventPrefix);
    controller.isIdle = true;
    method(controller, 'away').call(controller, event);

    if (dispatchEvent) {
      var clickOutsideEvent = extendedEvent(eventName, event || null, {
        controller: controller
      });
      controller.element.dispatchEvent(clickOutsideEvent);
    }
  };

  var dispatchBack = function dispatchBack(event) {
    var eventName = composeEventName('back', controller, eventPrefix);
    controller.isIdle = false;
    method(controller, 'back').call(controller, event);

    if (dispatchEvent) {
      var clickOutsideEvent = extendedEvent(eventName, event || null, {
        controller: controller
      });
      controller.element.dispatchEvent(clickOutsideEvent);
    }
  };

  var onEvent = function onEvent(event) {
    if (isIdle) dispatchBack(event);
    isIdle = false;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      isIdle = true;
      dispatchAway(event);
    }, ms);
  };

  var onVisibility = function onVisibility(event) {
    if (!document.hidden) onEvent(event);
  };

  if (isIdle) {
    dispatchAway();
  } else {
    dispatchBack();
  }

  var controllerDisconnect = controller.disconnect.bind(controller);

  var observe = function observe() {
    events.forEach(function (event) {
      window.addEventListener(event, onEvent);
    });
    document.addEventListener('visibilitychange', onVisibility);
  };

  var unobserve = function unobserve() {
    events.forEach(function (event) {
      window.removeEventListener(event, onEvent);
    });
    document.removeEventListener('visibilitychange', onVisibility);
  };

  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};